import { render, staticRenderFns } from "./BtnPrioritario.vue?vue&type=template&id=32385ca8"
import script from "./BtnPrioritario.vue?vue&type=script&lang=js"
export * from "./BtnPrioritario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports